import { ChartOptions } from 'chart.js'
import { calculateFollowers } from '../utils/pipes'
import { OptionTab } from 'interfaces'

export const CHART_DATA_EXAMPLE = {
  views: {
    options: [
      {
        labels: ['2016', '2017', '2018', '2019', '2020', '2021', '2022'],
        optionLabel: 'All time',
        datasets: [
          {
            label: '',
            datasets: [0, 76300, 93000, 111111, 145000, 110000, 190000],
          },
        ],
      },
      {
        labels: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        optionLabel: '1 year',
        datasets: [
          {
            label: '',
            datasets: [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56],
          },
        ],
      },
    ],
  },
  audience: {
    options: [
      {
        labels: ['2016', '2017', '2018', '2019', '2020', '2021', '2022'],
        optionLabel: 'All time',
        datasets: [
          {
            label: 'All social accounts',
            datasets: [0, 76300, 93000, 111111, 145000, 110000, 190000],
          },
          {
            label: 'Instagram',
            datasets: [0, 12300, 22300, 43111, 54000, 60000, 43000],
          },
          {
            label: 'Youtube',
            datasets: [0, 3300, 102000, 111111, 123000, 193000, 213000],
          },
        ],
      },
      {
        labels: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        optionLabel: '1 year',
        datasets: [
          {
            label: 'All social accounts',
            datasets: [
              122, 188, 240, 254, 281, 297, 299, 408, 409, 414, 424, 492,
            ],
          },
          {
            label: 'Instagram',
            datasets: [
              108, 135, 166, 175, 176, 281, 292, 325, 351, 373, 416, 449,
            ],
          },
          {
            label: 'Youtube',
            datasets: [
              112, 126, 151, 187, 197, 231, 250, 322, 348, 390, 399, 438,
            ],
          },
        ],
      },
    ],
  },
  countries: {
    options: [
      {
        labels: ['USA', 'Canada', 'UK', 'Australia', 'Other'],
        optionLabel: 'All time',
        datasets: [
          {
            label: 'All social accounts',
            datasets: [50, 23, 10, 17, 2],
          },
          {
            label: 'Instagram',
            datasets: [40, 32, 10, 17, 2],
          },
          {
            label: 'Youtube',
            datasets: [10, 23, 10, 17, 2],
          },
        ],
      },
    ],
  },
  ages: {
    options: [
      {
        labels: [
          '16 - 20 y.o.',
          '21 - 25 y.o.',
          '26 - 30 y.o,',
          '31 - 35 y.o.',
          '36 +',
        ],
        optionLabel: 'All time',
        datasets: [
          {
            label: 'Female',
            datasets: [50, 23, 10, 17, 2],
          },
          {
            label: 'Male',
            datasets: [40, 32, 10, 17, 2],
          },
        ],
      },
    ],
  },
  gender: {
    options: [
      {
        labels: ['Female', 'Male'],
        optionLabel: 'All time',
        datasets: [
          {
            label: '',
            datasets: [33, 77],
          },
        ],
      },
    ],
  },
  audienceInteraction: {
    options: [
      {
        labels: ['Instagram', 'Facebook', 'Youtube'],
        optionLabel: 'All time',
        datasets: [
          {
            label: '',
            datasets: [55, 23, 22],
          },
        ],
      },
    ],
  },
}

export const COLORS_CHART = ['#E832D2', '#7632E8', '#FF0000']

export const CHART_LINE_OPTIONS: ChartOptions = {
  responsive: true,
  scales: {
    x: {
      ticks: {
        color: '#949494',
      },
      grid: {
        color: '#949494', // TODO: Create option handler by theme
        lineWidth: 0.2,
      },
    },
    y: {
      grid: {
        color: '#949494',
        lineWidth: 0.2,
      },
      ticks: {
        color: '#949494',
        callback: (value: number) => {
          const formatNumber = calculateFollowers(value)
          return formatNumber.value + formatNumber.key
        },
      },
    },
  },
  plugins: {
    legend: {
      display: false,
      position: 'top' as const,
    },
  },
}

export const CHART_BAR_OPTIONS: ChartOptions = {
  ...CHART_LINE_OPTIONS,
  scales: {
    y: {
      min: 0,
      max: 100,
      stacked: true,
      beginAtZero: true,
      ticks: {
        color: '#949494',
        stepSize: 25,
        callback: function (value) {
          return value + '%'
        },
      },
    },
  },
}

export const CHART_PIE_OPTIONS: ChartOptions = {
  responsive: true,
  hover: {
    mode: 'nearest',
    intersect: false,
  },
  onHover: () => {
    // console.log('hover')
  },
  plugins: {
    legend: {
      display: false,
      position: 'top' as const,
    },
    tooltip: {
      enabled: false,
    },
  },
  scales: {
    y: {
      display: false,
    },
    x: {
      display: false,
    },
  },
}

export const EXAMPLE_OPTIONS: OptionTab[] = [
  { label: '1 Month', value: '1 month' },
  { label: '6 Months', value: '6 months' },
  { label: '1 Year', value: '1 year' },
  { label: 'All time', value: 'All time' },
]

export const EXAMPLE_SCORE = {
  engagementRate: {
    value: '29.86%',
    label: 'Engagement Rate',
    state: 'Excellent',
  },
  audienceGrowth: {
    value: '+7.34%',
    label: 'Audience Growth',
    state: 'Excellent',
  },
  followingUnfollowingRatio: {
    value: '10 : 1',
    label: 'Following : Unfollowing Ratio',
    state: 'Very good',
  },
  commentLikeRatio: {
    value: '10 : 120',
    label: 'Comment : Like Ratio',
    state: 'Very low',
  },
  contentDiversity: {
    value: '3/5',
    label: 'Content Diversity',
    state: 'Very good',
  },
  hashtagQuality: {
    value: 'A+',
    label: 'Hashtag Quality',
    state: 'Excellent',
  },
}

export const EXAMPLE_ACCOUNT_INSIHTS = {
  followers: {
    value: '1.2M',
    label: 'Followers',
  },
  following: {
    value: '1.2K',
    label: 'Following',
  },
  posts: {
    value: '1.8K',
    label: 'Posts',
  },
  avgLikes: {
    value: '2K',
    label: 'Avg Likes',
  },
  avgComments: {
    value: '230',
    label: 'Avg Comments',
  },
  engagement: {
    value: '9.86%',
    label: 'Engagement',
  },
}
